<div class="entrepreneur-prospect-dialog-aligned-commitments-part">
	<readonly-access [readonly]="dialogDataService.isReadonly()"></readonly-access>

	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()"
		[rows]="alignedCommitments()"></grid-content>
</div>